import type { Building } from "building-types/building/buildingTypes";
import makeGenerationStageComparator from "../utils/makeGenerationStageComparator";
import memo from "../utils/memo";
import {
  addPlanarGraphUnsupportedPerimeterVerticesToPerimeterInfo,
  getPlanarGraphPerimeterInfo,
  makePlanarGraphLevelAssociations,
} from "../utils/planarGraphPerimeters";

function select({ settings, levels, mirror, rooms, roomLevelIndices, roomsByLevel, planarGraphs }: Building) {
  return {
    levels,
    mirror,
    rooms,
    roomLevelIndices,
    roomsByLevel,
    planarGraphs,
    structureSettings: settings.structure,
  };
}

const compare = makeGenerationStageComparator<typeof select>({});

function generatePlanarGraphPerimeters({
  levels,
  planarGraphs,
  rooms,
  roomLevelIndices,
  roomsByLevel,
  structureSettings,
  mirror,
}: ReturnType<typeof select>): {
  planarGraphPerimeters: Building["planarGraphPerimeters"];
  planarGraphLevelAssociations: Building["planarGraphLevelAssociations"];
} {
  const planarGraphPerimeters = {};

  if (Object.keys(levels).length === 0) {
    return {
      planarGraphPerimeters,
      planarGraphLevelAssociations: {},
    };
  }

  for (const levelId in levels) {
    if (!planarGraphs[levelId]) {
      continue;
    }
    planarGraphPerimeters[levelId] = getPlanarGraphPerimeterInfo(
      roomsByLevel[levelId],
      planarGraphs[levelId],
      rooms,
      roomLevelIndices,
      mirror,
    );
  }

  addPlanarGraphUnsupportedPerimeterVerticesToPerimeterInfo(
    levels,
    planarGraphs,
    planarGraphPerimeters,
    structureSettings,
  );

  const planarGraphLevelAssociations = makePlanarGraphLevelAssociations(levels, planarGraphs);

  return {
    planarGraphPerimeters,
    planarGraphLevelAssociations,
  };
}

export default memo(select, generatePlanarGraphPerimeters, compare);
